import '../../../../models/common/dashboard/refresh_interval_model.js.coffee'
import '../charts/refresh_interval_picker_view.js.coffee'
import './navbar_menu_view.js.coffee'
import './account_data_view.js.coffee'

Namespace 'Common.Dashboard.Navbar'

class Common.Dashboard.NavbarView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/navbar/navbar']
  className: 'shared-session-navbar'

  events:
    'click .options-button-container': '_openMenu'
    'click .refresh-button': '_refreshCharts'
    'click .filters-button': '_showFilters'

  initialize: ({sharedSession, accountData}) ->
    @sharedSession = sharedSession
    @accountData = accountData
    @refreshInterval = new Common.Dashboard.RefreshIntervalModel()
    @refreshIntervalPickerView = new Common.Dashboard.Charts.RefreshIntervalPickerView({@refreshInterval})
    @menuView = new Common.Dashboard.Navbar.NavbarMenuView(
      sharedSession: @sharedSession,
      accountData: @accountData,
      refreshInterval: @refreshInterval
    )
    @listenTo(@sharedSession, 'session:execution', @_modifyLastUpdated)
    @listenTo(@refreshInterval, 'change', @_resetRefreshInterval)
    @listenTo(@menuView, 'session:execution', @_modifyLastUpdated)

  render: ->
    @$el.html @template
      lastUpdatedDate: @_currentDate()
      title: @sharedSession.get('title')
    @_renderAccountData()
    @_renderRefreshIntervalPicker()
    @_renderMenu()
    @_addMobileHoverFix()
    @

  _addMobileHoverFix: ->
    # On mobile, when you click a button, it keeps hovered
    refreshButton = @$el.find('.refresh-button')
    refreshButton.on('click', -> refreshButton.blur())
    refreshButton.on('touchstart', -> refreshButton.removeClass('mobile-hover'))
    refreshButton.on('touchend', -> refreshButton.addClass('mobile-hover'))

  _renderAccountData: ->
    @accountDataView?.remove()
    @accountDataView = new Common.Dashboard.Navbar.AccountDataView(accountData: @accountData)
    @$('.account-data-container').html(@accountDataView.render().el)

  _renderRefreshIntervalPicker: ->
    @$('#autorefresh-period').html(@refreshIntervalPickerView.render().el)

  _openMenu: ->
    @menuView.open()

  _renderMenu: ->
    @$('.menu-container').html(@menuView.render().el)

  _resetRefreshInterval: ->
    refreshIntervalSeconds = @refreshInterval.get('selectedOption')
    clearInterval(@refreshIntervalID) if @refreshIntervalID
    return if !refreshIntervalSeconds || refreshIntervalSeconds == 0
    @refreshIntervalID = setInterval(
      @refresh,
      refreshIntervalSeconds * 1000
    )

  refresh: =>
    return if document.hidden
    @_refreshCharts()

  _refreshCharts: ->
    @$('.fa-refresh').addClass('fa-spin')
    @sharedSession.execute()

  _modifyLastUpdated: =>
    date = @_currentDate()
    @$('.last-updated-date').text(date)
    @menuView.setLastUpdatedDate(date)
    @$('.fa-refresh').removeClass('fa-spin')

  _currentDate: ->
    moment().format('HH:mm - DD/MM/YYYY')

  _showFilters: ->
    @trigger('filters:show')
